const BTN_SIZES = ['small', 'medium', 'large', 'sm', 'md', 'lg', 'xs'] as const;
export type ButtonSize = (typeof BTN_SIZES)[number];

const BTN_COLORS = [
  'primary',
  'secondary',
  'warning',
  'danger',
  'info',
  'success',
  'link',
  'light',
  'default',
] as const;
export type ButtonColor = (typeof BTN_COLORS)[number];

export const BTN_SIZE_DICT: Record<ButtonSize, string> = {
  small: 'btn-sm',
  medium: 'btn-md',
  large: 'btn-lg',
  sm: 'btn-sm',
  md: 'btn-md',
  lg: 'btn-lg',
  xs: 'btn-xs',
};

export const BTN_CLASS_DICT: Record<ButtonColor, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  warning: 'btn-warning',
  danger: 'btn-danger',
  info: 'btn-info',
  success: 'btn-success',
  link: 'btn-link',
  light: 'btn-light',
  default: 'btn-default',
};

export const BTN_OUTLINE_CLASS_DICT: Record<ButtonColor, string> = {
  primary: 'btn-outline-primary',
  secondary: 'btn-outline-secondary',
  warning: 'btn-outline-warning',
  danger: 'btn-outline-danger',
  info: 'btn-outline-info',
  success: 'btn-outline-success',
  link: 'btn-outline-link',
  light: 'btn-outline-light',
  default: 'btn-outline-default',
};
